// Shared colored status pill for commitments & installments.
// Sits in the middle of each row so the state is instantly obvious.
import { CheckCircle2, AlertTriangle, Wallet, Clock } from "lucide-react";

const MAP = {
  paid:     { Icon: CheckCircle2,  cls: "bg-emerald-100 text-emerald-700",       label: { en: "Paid",     ar: "مدفوع" } },
  done:     { Icon: CheckCircle2,  cls: "bg-emerald-100 text-emerald-700",       label: { en: "Done",     ar: "مكتمل" } },
  overdue:  { Icon: AlertTriangle, cls: "bg-rose-100 text-rose-700 animate-pulse", label: { en: "Unpaid",  ar: "غير مدفوع" } },
  unpaid:   { Icon: AlertTriangle, cls: "bg-rose-100 text-rose-700",             label: { en: "Unpaid",   ar: "غير مدفوع" } },
  due:      { Icon: Wallet,        cls: "bg-amber-100 text-amber-800",           label: { en: "Due today", ar: "مستحق" } },
  soon:     { Icon: Clock,         cls: "bg-sky-100 text-sky-700",               label: { en: "Soon",     ar: "قريباً" } },
  upcoming: { Icon: Clock,         cls: "bg-slate-100 text-slate-600",           label: { en: "Upcoming", ar: "لاحقاً" } },
};

export function StatusPill({ status, lang, testId }) {
  const b = MAP[status] || MAP.upcoming;
  return (
    <span data-testid={testId}
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-extrabold whitespace-nowrap ${b.cls}`}>
      <b.Icon className="w-3 h-3" />
      {b.label[lang] || b.label.en}
    </span>
  );
}

export function installmentStatus(inst) {
  if ((inst.paid_count || 0) >= (inst.total_installments || 0)) return "done";
  if (inst.is_overdue) return "overdue";
  const due = inst.next_due;
  if (!due) return "upcoming";
  const d = Math.round((new Date(due) - new Date()) / 864e5);
  if (d < 0) return "overdue";
  if (d === 0) return "due";
  if (d <= 3) return "soon";
  return "upcoming";
}
